import React from 'react';
import classnames from 'classnames';
import { Button as AntButton } from 'antd';
import './style.scss';
import { noop } from 'lodash';

export const Type = {
    Default: 'default-type',
    Primary: 'primary-type',
    Secondary: 'secondary-type',
    Tertiary: 'tertiary-type',
    Link: 'link-type',
    Clear: 'clear-type'
};

/**
 * Button component - multiple uses.
 * 
 * @param {Object} props - Props for the Button component.
 * @param {ReactNode} props.children - Children to be added inside component.
 * @param {string} props.type - Text for the button type.
 * @param {string} props.uppercase - CSS property 'uppercase'.
 * @param {Object} [props] - Additional props to be spread on the AntButton component.
 * @returns {JSX.Element} The Button component.
 * @example
 * <Button
 *  className='test-classname'
 *  // optional Ant Button props:
 *  block={true}
 *  icon={IconName}
 *  // ...
 * >
 *  ...
 * </Button>
 */
function Button({ children, type, uppercase, ...props }) {

    const className = classnames("cit-btn", type, {
        [ props.className ]: props.className,
        uppercase
    });

    return (
        <AntButton {...props} className={className}>{ children }</AntButton>
    );
}

Button.defaultProps = {
    children: noop,
    type: Type.Default,
    uppercase: 'uppercase',
};


export default Button;
